import { RotateCcw, Home, Trophy, Flame } from "lucide-react";
import { DIFFICULTIES } from "@/game/config";
import { PixelButton } from "./PixelButton";

export const StatGrid = ({ stats }) => (
  <div className="stat-grid" data-testid="run-stats">
    {[
      ["Score", stats.score.toLocaleString(), "stat-score"],
      ["Level", `${stats.level}/10`, "stat-level"],
      ["Toast", stats.toast, "stat-toast"],
      ["Defeated", stats.kills, "stat-kills"],
      ["Mode", DIFFICULTIES[stats.difficulty].label, "stat-mode"],
      ["Time", `${Math.floor(stats.time / 60)}m ${stats.time % 60}s`, "stat-time"],
    ].map(([k, v, id]) => (
      <div key={k} className="stat" data-testid={id}><span>{k}</span><strong>{v}</strong></div>
    ))}
  </div>
);

export const GameOverScreen = ({ stats, onRetry, onHome }) => (
  <div className="center-screen" data-testid="game-over-screen">
    <div className="panel fade-up">
      <p className="eyebrow red">All three lives lost</p>
      <h1 className="big-title red">Burnt Toast</h1>
      <p className="lede">The roguelike way: back to level 1. Your weapon resets, but your achievements stay forever.</p>
      <StatGrid stats={stats} />
      <div className="title-actions">
        <PixelButton onClick={onRetry} data-testid="retry-button"><RotateCcw size={16} /> Try Again</PixelButton>
        <PixelButton variant="ghost" onClick={onHome} data-testid="home-button"><Home size={16} /> Title</PixelButton>
      </div>
    </div>
  </div>
);

export const DailyResultScreen = ({ stats, result, onLeaderboard, onHome }) => (
  <div className="center-screen" data-testid="daily-result-screen">
    <div className="panel fade-up">
      <p className="eyebrow">Daily Challenge · {result?.date}</p>
      <h1 className="big-title" style={{ color: stats.completed ? "var(--butter)" : "var(--heart)" }}>
        {stats.completed ? "Daily Cleared" : "Daily Failed"}
      </h1>
      <p className="lede" data-testid="daily-best">
        {result ? (result.new_best ? "New personal best for today!" : `Today's best: ${result.best.score.toLocaleString()}`) : "Saving score..."}
      </p>
      {result?.streak > 0 && (
        <p className="streak-chip" data-testid="daily-streak">
          <Flame size={18} /> {result.streak}-day streak{result.reward ? ` · +${result.reward} gems earned!` : ""}
        </p>
      )}
      <StatGrid stats={stats} />
      <div className="title-actions">
        <PixelButton onClick={onLeaderboard} data-testid="daily-leaderboard-button"><Trophy size={16} /> Daily Leaderboard</PixelButton>
        <PixelButton variant="ghost" onClick={onHome} data-testid="daily-home-button"><Home size={16} /> Title</PixelButton>
      </div>
    </div>
  </div>
);
